import {
  Object3D,
  PlaneGeometry,
  Mesh,
  TextureLoader,
  RawShaderMaterial,
} from 'three'
import { gsap } from 'gsap'

import vertexShader from './stars.vert.glsl'
import fragmentShader from './stars.frag.glsl'
import { component } from '../../bidello'
import camera from '../camera'

const randomFloat = (min, max) => ((Math.random() * (max - min)) + min)

// const resources = [
//   {
//     name: 'stars',
//     src: '/app/themes/rewild-yourself/dist/images/inspire-stars.webp'
//   },
// ]

class Stars extends component(Object3D) {
  constructor() {
    super()
    this.loader = new TextureLoader()
    this.visible = false
    this.mesh = null
    this.isMobile = window.innerWidth < 768
    this.start()
  }

  async start() {
    const texture = await this.getTexture('/app/themes/rewild-yourself/dist/images/home-stars.webp')
    const material = new RawShaderMaterial({
      vertexShader,
      fragmentShader,
      transparent: true,
      uniforms: {
        uTime: { value: 0 },
        uTranslate: { value: [0, 0, 0] },
        uScaleFactor: { value: 1 },
        uDisplaceFactor: { value: 0 },
        uSeed: { value: randomFloat(8, 12) },
        uTexture: { value: texture },
      }
    })

    const geometry = new PlaneGeometry(1, 1, 10, 10)
    const mesh = new Mesh(geometry, material)
    mesh.position.z = 0

    mesh.needsUpdate = true
    material.needsUpdate = true
    // mesh.name = texture.name

    this.add(mesh)
    this.mesh = mesh
    // this.mesh.visible = true

    // this.textures.forEach((tex, i) => {
    //   const mesh = this.createMesh(tex, i)
    //   this.meshes.push(mesh)

    //   if (mesh.name === 'stars') {
    //     this.starField = mesh
    //   }
    // })

    this.setScale()

    window.addEventListener('resize', this.setScale.bind(this))

    // this.enter()
  }

  async getTexture(url) {
    return new Promise((resolve) => {
      this.loader.load(url, tex => {
        // tex.name = res.name
        return resolve(tex)
      })
    })
  }

  setScale() {
    this.isMobile = window.innerWidth < 768

    // this.meshes.forEach(mesh => {
      const cameraSize = camera.calculateUnitSize(10 - this.mesh.position.z)

      const width = this.isMobile ? window.innerHeight * 1.8 : window.innerWidth
      const height = window.innerHeight

      const w = (width * cameraSize.width) / window.innerWidth
      const h = (height * cameraSize.height) / window.innerHeight
      this.mesh.scale.set(w, h, 1)
    // })
  }

  // createMesh(texture, i) {
  //   const material = new RawShaderMaterial({
  //     vertexShader,
  //     fragmentShader,
  //     transparent: true,
  //     uniforms: {
  //       uTime: { value: 0 },
  //       uTranslate: { value: [0, 0, 0] },
  //       uScaleFactor: { value: 1 },
  //       uDisplaceFactor: { value: 0 },
  //       uSeed: { value: randomFloat(8, 12) },
  //       uTexture: { value: texture },
  //     }
  //   })

  //   const geometry = new PlaneGeometry(1, 1, 10, 10)
  //   const mesh = new Mesh(geometry, material)
  //   mesh.position.z = i

  //   mesh.needsUpdate = true
  //   material.needsUpdate = true
  //   mesh.name = texture.name

  //   this.add(mesh)
  //   return mesh
  // }

  enter() {
    console.log('stars enter')
    this.visible = true

    const tl = gsap.timeline({
      onComplete: () => {
      // scroll.locoScroll.on('scroll', this.bindedHandle)
      // scroll.start()
      }
    })

    // this.meshes.forEach((mesh, i) => {
      // if (mesh.name === 'heart') {
      //   gsap.from(mesh.material.uniforms.uScaleFactor, {
      //     value: 1.3,
      //     duration: 2,
      //     ease: 'power2.inOut'
      //   })
      // }

      tl
        .fromTo(this.mesh.material.uniforms.uTime, {
          value: 0
        },{
          value: 1,
          duration: 2,
          ease: 'power2.inOut'
        })
    // })
  }

  fastLeave() {
    console.log('leave')
    // scroll.locoScroll.off('scroll', this.bindedHandle)

    // this.meshes.forEach((mesh, i) => {
    //   gsap.to(mesh.material.uniforms.uTime, {
    //     value: 0,
    //     duration: 1.6,
    //     ease: 'power4.Out',
    //     onComplete: () => {
    //       this.visible = false
    //     }
    //   })
    // })

    gsap.to(this.mesh.material.uniforms.uTime, {
      value: 0,
      duration: 1.6,
      ease: 'power4.Out',
      onComplete: () => {
        this.visible = false
      }
    })
  }

  fastEnter() {
    this.visible = true

    // this.meshes.forEach((mesh, i) => {
    //   gsap.to(mesh.material.uniforms.uTime, {
    //     value: 1,
    //     duration: 1.6,
    //     ease: 'power4.Out'
    //   })
    // })
    gsap.to(this.mesh.material.uniforms.uTime, {
      value: 1,
      duration: 1.6,
      ease: 'power4.Out'
    })
  }

  // handleScroll({ scroll }) {
  //   this.meshes.forEach((mesh, i) => {
  //     mesh.material.uniforms.uTime.value = 1 - (scroll.y * 1.5 / window.innerHeight)
  //     mesh.material.uniforms.uTranslate.value = [0, (scroll.y * (i / 2) / window.innerHeight), 0]
  //   })
  // }

  resetMeshes() {
    this.mesh.material.uniforms.uTime.value = 0
    this.mesh.material.uniforms.uTranslate.value = [0, 0, 0]
    // this.meshes.forEach((mesh, i) => {
    //   mesh.material.uniforms.uTime.value = 0
    //   mesh.material.uniforms.uTranslate.value = [0, 0, 0]
    // })
  }

  onRaf({now}) {
    if (this.visible && this.mesh) {
      this.mesh.material.uniforms.uDisplaceFactor.value = now * 1.4
    }
  }
}

export default new Stars()
